
import React, { useEffect } from 'react';
import MatrixBackground from '../components/MatrixBackground';
import ScanLines from '../components/ScanLines';
import Header from '../components/Header';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const ContactPage = () => {
  useEffect(() => {
    // Change title
    document.title = 'Contact | SpecialAgentK';
  }, []);

  return (
    <div className="bg-cyber-black text-cyber-green min-h-screen">
      <MatrixBackground />
      <ScanLines />
      <Header />
      <div className="pt-28">
        <Contact />
      </div>
      <Footer />
    </div>
  );
};

export default ContactPage;
